module.exports = __webpack_public_path__ + "img/main-02-02.b8852000.png";